import { render, staticRenderFns } from "./RezultatiKolo.vue?vue&type=template&id=30c44df8&scoped=true&"
import script from "./RezultatiKolo.vue?vue&type=script&lang=js&"
export * from "./RezultatiKolo.vue?vue&type=script&lang=js&"
import style0 from "./RezultatiKolo.vue?vue&type=style&index=0&id=30c44df8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c44df8",
  null
  
)

export default component.exports